import { ButtonSetting } from '@/fsd/shared/ui';
import { FilterPanel } from '@/fsd/shared/ui/filter-panel';
import { observer } from 'mobx-react-lite';
import { useRef } from 'react';
import RemainsStore from '../../model/store/RemainsStore';
import styles from '../Remains/Remains.module.scss';
import RemainsTableSettings from '../RemainsTableSettings/RemainsTableSettings';

const RemainsFilters = observer(() => {
  const showSettingsButtonRef = useRef<HTMLButtonElement>(null);

  const {
    activeFilters,
    handleFilterApply,
    handleFilterChange,
    toggleSettings,
  } = RemainsStore;

  return (
    <>
      <FilterPanel
        fields={RemainsStore.filterFields}
        values={activeFilters}
        setValues={handleFilterChange}
        onSearch={handleFilterApply}
        table_name="remains"
      >
        <div className={styles.filterButtonsRow}>
          <FilterPanel.PrimaryButtons />
          <ButtonSetting
            onClick={toggleSettings}
            buttonRef={showSettingsButtonRef}
          />
        </div>
        <FilterPanel.Filters />
        <FilterPanel.SavedFilters />
      </FilterPanel>
      <RemainsTableSettings showSettingsButtonRef={showSettingsButtonRef} />
    </>
  );
});

export default RemainsFilters;
